// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%236B7280%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23d14343%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datasetGallery {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  padding: 10px;
}

.card {
  margin-left: 0;
  margin-bottom: 0;
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: visible !important;
  background: white !important;
  position: relative;
}

.card:hover {
  transform: translateY(-4px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}

.card-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  color: #1F2937;
  font-size: 1.1rem;
  margin-bottom: 0;
}

.card-body {
  max-width: 18rem;
  padding: 1.25rem !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  overflow: visible !important;
}

.card-body .btn-light {
  width: 100%;
  background-color: transparent !important;
  border: none !important;
  padding: 8px 12px !important;
  margin-bottom: 8px;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.card-body .btn-light:hover {
  background-color: #F3F4F6 !important;
}

.card-text {
  overflow: hidden;
  text-overflow: ellipsis;
  color: #6B7280;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-bottom: 4px;
  text-align: center;
  width: 100%;
}

/* 优化按钮样式 */
.card-body .btn {
  border-radius: 8px !important;
  font-weight: 500 !important;
  padding: 10px 20px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  border: none !important;
  text-transform: none !important;
  letter-spacing: 0.3px;
  width: 100%;
  margin: 4px 0;
}

.card-body .btn-outline-secondary {
  background-color: white !important;
  color: #6B7280 !important;
  border: 2px solid #E5E7EB !important;
}

.card-body .btn-outline-secondary:hover {
  background-color: #F9FAFB !important;
  color: #374151 !important;
  border-color: #D1D5DB !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.card-body .btn-outline-primary {
  background-color: white !important;
  color: #3B82F6 !important;
  border: 2px solid #3B82F6 !important;
}

.card-body .btn-outline-primary:hover {
  background-color: #3B82F6 !important;
  color: white !important;
  border-color: #3B82F6 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
}

.card-body .btn-primary {
  background-color: #3B82F6 !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25) !important;
}

.card-body .btn-primary:hover {
  background-color: #2563EB !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35) !important;
}

.card-body .btn-secondary {
  background-color: #6B7280 !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(107, 114, 128, 0.25) !important;
}

.card-body .btn-secondary:hover {
  background-color: #4B5563 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(107, 114, 128, 0.35) !important;
}

.card-body .btn-danger {
  background-color: #EF4444 !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25) !important;
}

.card-body .btn-danger:hover {
  background-color: #DC2626 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35) !important;
}

.card-body .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.add-group {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.dataset-option {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.dataset-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 24px;
  margin: 0 0 24px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 美化顶部按钮栏中的按钮 */
.dataset-option .btn {
  border-radius: 8px !important;
  font-weight: 500 !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  border-width: 2px !important;
  letter-spacing: 0.3px;
  text-transform: none !important;
}

/* Toolbar uses org-btn — legacy Bootstrap overrides removed */

.dataset-option .btn-secondary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25) !important;
}

.dataset-option .btn-secondary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.35) !important;
}

.dataset-option .btn-outline-danger {
  background-color: #fff5f5 !important;
  color: #e53e3e !important;
  border-color: #feb2b2 !important;
}

.dataset-option .btn-outline-danger:hover {
  background-color: #e53e3e !important;
  color: white !important;
  border-color: #e53e3e !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3) !important;
}

/* 美化 Create new dataset 按钮 */
.add-group .btn-primary {
  background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%) !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 12px 28px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 14px rgba(49, 130, 206, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.add-group .btn-primary:hover {
  transform: translateY(-3px) scale(1.02) !important;
  box-shadow: 0 8px 20px rgba(49, 130, 206, 0.4) !important;
}

.add-group .btn-primary:active {
  transform: translateY(-1px) scale(0.98) !important;
}

/* Tab标签页优化 */
.nav-tabs {
  border-bottom: 2px solid #e2e8f0 !important;
  margin-bottom: 24px;
}

.nav-tabs .nav-link {
  border: none !important;
  color: #718096 !important;
  font-weight: 500 !important;
  padding: 12px 24px !important;
  margin-right: 4px !important;
  border-radius: 8px 8px 0 0 !important;
  transition: all 0.3s ease !important;
  position: relative;
}

.nav-tabs .nav-link:hover {
  color: #667eea !important;
  background-color: #f7fafc !important;
}

.nav-tabs .nav-link.active {
  color: #667eea !important;
  background-color: transparent !important;
  border-bottom: 3px solid #667eea !important;
  font-weight: 600 !important;
}

/* 复选框美化 */
.form-check-input {
  width: 20px !important;
  height: 20px !important;
  border-radius: 6px !important;
  border: 2px solid #D1D5DB !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  background-color: white !important;
}

.form-check-input:checked {
  background-color: #3B82F6 !important;
  border-color: #3B82F6 !important;
}

.form-check-input:hover {
  border-color: #3B82F6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.form-check-input:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;
}

/* 数据集卡片上的关闭按钮 - 默认隐藏，只在卡片hover时显示（卡片角删除钮除外） */
.card .btn-close:not(.dataset-card-delete) {
  opacity: 0 !important;
  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease !important;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background-color: transparent;
}

.card:hover .btn-close:not(.dataset-card-delete) {
  opacity: 0.6 !important;
}

.card .btn-close:not(.dataset-card-delete):hover {
  background-color: #FEE2E2 !important;
  opacity: 1 !important;
}

.dataset-card .btn-close:hover {
  transform: none !important;
}

/* 卡片内输入框和选择框样式 */
.card-body input[type="text"],
.card-body input[type="number"],
.card-body input[type="email"],
.card-body input[type="password"],
.card-body select,
.card-body textarea {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  transition: all 0.3s ease;
  margin: 4px 0;
}

.card-body input[type="text"]:focus,
.card-body input[type="number"]:focus,
.card-body input[type="email"]:focus,
.card-body input[type="password"]:focus,
.card-body select:focus,
.card-body textarea:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.card-body input[type="text"]:hover,
.card-body input[type="number"]:hover,
.card-body input[type="email"]:hover,
.card-body input[type="password"]:hover,
.card-body select:hover,
.card-body textarea:hover {
  border-color: #3B82F6;
}

.card-body input::placeholder,
.card-body textarea::placeholder {
  color: #9CA3AF;
}

/* 卡片内select下拉箭头 */
.card-body select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  cursor: pointer;
}

/* 搜索框和分页选择框样式 */
.form-control:focus,
.form-select:focus {
  border-color: #3B82F6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  outline: none !important;
}

.form-control:hover,
.form-select:hover {
  border-color: #3B82F6 !important;
}

.datasets {
  --dataset-card-control-height: 38px;
  --dataset-card-preview-height: 92px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto 40px;
}

.dataset-overview {
  margin-bottom: 20px;
}

.dataset-page-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  margin-bottom: 16px;
}

.dataset-page-heading h1 {
  margin: 0;
  color: #111827;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.dataset-page-heading p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.dataset-kicker {
  margin: 0 0 4px !important;
  color: #2563eb !important;
  font-size: 12px !important;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.dataset-status-pill,
.dataset-page-heading .org-count-badge {
  flex-shrink: 0;
}

.dataset-metric-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
}

.dataset-metric-card {
  position: relative;
  overflow: hidden;
  min-height: 92px;
  padding: 18px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #ffffff;
}

.dataset-metric-card::after {
  content: "";
  position: absolute;
  right: 16px;
  top: 18px;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: currentColor;
  opacity: 0.12;
}

.dataset-metric-card strong {
  display: block;
  margin-top: 12px;
  color: #111827;
  font-size: 26px;
  line-height: 1;
}

.metric-label {
  color: #6b7280;
  font-size: 13px;
  font-weight: 600;
}

.metric-blue { color: #2563eb; }
.metric-green { color: #16a34a; }
.metric-violet { color: #7c3aed; }
.metric-orange { color: #f97316; }
.metric-slate { color: #64748b; }

.dataset-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #ffffff;
}

.dataset-toolbar-actions,
.dataset-toolbar-search {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.dataset-toolbar-search {
  flex-wrap: nowrap;
}

.dataset-selection-status {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.dataset-toolbar-search label {
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.dataset-toolbar-search .form-control {
  width: 280px;
  min-height: 38px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
}

/* Shared dataset-card controls use the Data Acquisition dimensions. */
.dataset-card-body .org-btn,
.dataset-card-body .btn:not(.dataset-title-button) {
  width: 100%;
  height: var(--dataset-card-control-height);
  min-height: var(--dataset-card-control-height);
  max-height: var(--dataset-card-control-height);
  padding: 0 14px !important;
  box-sizing: border-box;
  font-size: 13px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dataset-toolbar .org-btn {
  min-height: 40px;
  padding: 9px 16px;
  font-size: 13px;
  white-space: nowrap;
}

.dataset-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.datasetGallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
  padding: 0;
}

.dataset-card.card {
  position: relative;
  align-items: stretch;
  width: 100% !important;
  min-height: 236px;
  margin: 0;
  border: 1px solid #e6edf7 !important;
  border-radius: 16px !important;
  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04) !important;
  background: #ffffff !important;
  overflow: hidden;
}

.dataset-card .btn-close:not(.dataset-card-delete) {
  position: static;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  border-radius: 6px;
  opacity: 0.55 !important;
  transition: background 160ms ease, color 160ms ease, opacity 160ms ease;
}

.dataset-card .dataset-card-delete {
  position: relative;
  justify-self: end;
  grid-column: 3;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 6px;
  opacity: 0 !important;
  pointer-events: none;
  transition: opacity 160ms ease, background 160ms ease;
}

.dataset-card:hover .dataset-card-delete {
  opacity: 0.55 !important;
  pointer-events: auto;
}

.dataset-card-actions .btn-close:hover,
.dataset-card .dataset-card-delete:hover {
  background-color: #fde8e8 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-size: 1em auto !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  opacity: 1 !important;
  transform: none;
}

.dataset-card.card:has(.form-check-input:checked) {
  border-color: #60a5fa !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
}

.dataset-card.card:hover {
  transform: none !important;
  border-color: #bfdbfe !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;
}

.dataset-card-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  column-gap: 8px;
  width: 100%;
  padding: 12px 12px 0;
  box-sizing: border-box;
}

.dataset-card-checkbox {
  position: relative !important;
  float: none !important;
  top: auto !important;
  left: auto !important;
  margin: 0 !important;
  grid-column: 1;
  justify-self: start;
  width: 20px !important;
  height: 20px !important;
}

.dataset-card-badges {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: wrap;
  grid-column: 2;
  justify-self: center;
}

.dataset-card-badges .org-role-badge {
  text-transform: capitalize;
  font-size: 11px;
}

.dataset-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dataset-card-actions .org-role-badge {
  text-transform: capitalize;
  font-size: 11px;
}

.dataset-card-body.card-body {
  width: 100%;
  max-width: none;
  align-items: stretch;
  padding: 12px 16px 16px !important;
  gap: 10px;
  min-height: 180px;
  box-sizing: border-box;
}

.dataset-card-body > * {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.dataset-title-button.btn-light {
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
  text-align: left;
}

.dataset-title-button .card-title {
  color: #0f172a;
  font-size: 16px;
}

.dataset-card-preview {
  height: var(--dataset-card-preview-height);
  min-height: var(--dataset-card-preview-height);
  max-height: var(--dataset-card-preview-height);
  flex: 0 0 var(--dataset-card-preview-height);
  align-self: stretch;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-sizing: border-box;
  background:
    linear-gradient(135deg, rgba(37, 99, 235, 0.12), rgba(14, 165, 233, 0.06)),
    repeating-linear-gradient(45deg, #f8fafc 0, #f8fafc 8px, #f1f5f9 8px, #f1f5f9 16px);
}

.dataset-card-preview.is-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cbd5e1;
  background: #f8fafc;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
}

.dataset-card-preview.has-image {
  background: #f8fafc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.dataset-card-preview.has-audio-waveform {
  background-color: #f5f3ff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.dataset-media-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.media-image { background: #ecfdf5; color: #047857; }
.media-audio { background: #f5f3ff; color: #6d28d9; }
.media-table { background: #fff7ed; color: #c2410c; }

.dataset-status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.status-ready {
  background: #ecfdf5;
  color: #047857;
}

.status-empty {
  background: #fff7ed;
  color: #c2410c;
}

.dataset-card-footer {
  margin-top: auto;
  padding-top: 12px;
}

.dataset-view-details {
  width: 100%;
  min-height: 38px;
  border: 1px solid #111827;
  border-radius: 8px;
  background: #111827;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease;
}

.dataset-view-details:hover {
  background: #1f2937;
  border-color: #1f2937;
}

.dataset-gallery-summary {
  margin-top: 14px;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}

.dataset-enterprise-modal .modal-content {
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

.dataset-modal-header {
  border-bottom: 1px solid #e5e7eb !important;
  padding: 18px 22px !important;
}

.dataset-modal-header .modal-title {
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
}

.dataset-modal-body {
  padding: 22px !important;
  background: #ffffff;
}

.dataset-modal-form {
  display: grid;
  gap: 18px;
}

.dataset-modal-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dataset-modal-field label {
  margin: 0;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}

.dataset-modal-field input,
.dataset-modal-field .form-control,
.dataset-modal-field select {
  min-height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  color: #0f172a;
  font-size: 14px;
}

.dataset-modal-field input:focus,
.dataset-modal-field .form-control:focus,
.dataset-modal-field select:focus {
  border-color: #2563eb !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
}

.dataset-file-dropzone {
  display: grid;
  gap: 10px;
  padding: 14px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  transition: border-color 160ms ease, background 160ms ease;
}

.dataset-file-dropzone.is-drag-active {
  border-color: #2563eb;
  background: #eff6ff;
}

.dataset-file-dropzone.is-disabled {
  opacity: 0.65;
  pointer-events: none;
}

.dataset-file-dropzone input[type="file"] {
  display: none;
}

.dataset-file-input {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-file-browse {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid #111827;
  border-radius: 8px;
  background: #111827;
  color: #ffffff !important;
  cursor: pointer;
  font-size: 14px !important;
  font-weight: 600 !important;
  transition: background 160ms ease;
}

.dataset-file-browse:hover {
  background: #1f2937;
}

.dataset-file-name {
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-file-drop-hint {
  margin: 0;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
}

.dataset-modal-panel {
  display: grid;
  gap: 14px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f8fafc;
}

.dataset-modal-link {
  color: #2563eb !important;
  cursor: pointer;
  font-weight: 800;
  text-decoration: none !important;
}

.dataset-modal-footer.org-modal-footer {
  flex-wrap: wrap;
  justify-content: space-between;
}

.dataset-modal-tip {
  flex: 1 1;
  margin: 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.dataset-modal-actions {
  margin-left: auto;
}

.dataset-modal-actions .org-btn {
  min-height: 40px;
  font-size: 14px;
}

.dataset-modal-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.dataset-modal-progress progress {
  flex: 1 1;
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
}

.dataset-modal-progress span {
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}

.dataset-tab-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.dataset-tab-count {
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.nav-tabs {
  border-bottom: 1px solid #e5e7eb !important;
  margin-bottom: 18px;
}

.nav-tabs .nav-link {
  border-radius: 10px 10px 0 0 !important;
  color: #64748b !important;
}

.nav-tabs .nav-link.active {
  color: #2563eb !important;
  border-bottom: 2px solid #2563eb !important;
}

.dataset-search-hint {
  display: inline-flex;
  margin-bottom: 12px;
  padding: 7px 12px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 600;
}

.dataset-empty-state {
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  background: #f8fafc;
  padding: 40px;
  text-align: center;
  color: #64748b;
}

.dataset-toolbar {
  min-height: 58px;
  gap: 12px;
}

.dataset-toolbar-actions,
.dataset-toolbar-search {
  gap: 12px;
}

.dataset-toolbar-search label,
.dataset-toolbar-search .form-control {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
}

.dataset-toolbar-search label {
  margin: 0;
  color: #334155;
}

.dataset-toolbar-search .form-control {
  width: 280px;
  min-height: 40px;
  color: #0f172a;
}

.dataset-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.dataset-group-header h3 {
  margin: 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
}

.dataset-empty-trash-button {
  min-height: 36px;
  padding: 7px 12px;
  white-space: nowrap;
}

@media (max-width: 1100px) {
  .dataset-metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dataset-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .dataset-toolbar-search,
  .dataset-toolbar-search .form-control {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dataset.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,oDAAoD;EACpD,4DAA4D;EAC5D,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;EAChC,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;EACpC,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,8DAA8D;;AAE9D;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;EAChC,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA,6BAA6B;AAC7B;EACE,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,yDAAyD;EACzD,4DAA4D;AAC9D;;AAEA;EACE,kDAAkD;EAClD,yDAAyD;AAC3D;;AAEA;EACE,kDAAkD;AACpD;;AAEA,aAAa;AACb;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,8CAA8C;AAC9C;EACE,qBAAqB;EACrB,yFAAyF;EACzF,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;;EAEE,gCAAgC;EAChC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe,cAAc,EAAE;AAC/B,gBAAgB,cAAc,EAAE;AAChC,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,gBAAgB,cAAc,EAAE;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sEAAsE;AACtE;;EAEE,WAAW;EACX,0CAA0C;EAC1C,8CAA8C;EAC9C,8CAA8C;EAC9C,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,yDAAyD;EACzD,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;;EAEE,oCAAoC;EACpC,oEAAyV;EACzV,oCAAoC;EACpC,sCAAsC;EACtC,uCAAuC;EACvC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,8CAA8C;EAC9C,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB;;uFAEqF;AACvF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".datasetGallery {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 24px;\n  padding: 10px;\n}\n\n.card {\n  margin-left: 0;\n  margin-bottom: 0;\n  border-radius: 16px !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  overflow: visible !important;\n  background: white !important;\n  position: relative;\n}\n\n.card:hover {\n  transform: translateY(-4px) !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;\n}\n\n.card-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 600;\n  color: #1F2937;\n  font-size: 1.1rem;\n  margin-bottom: 0;\n}\n\n.card-body {\n  max-width: 18rem;\n  padding: 1.25rem !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  overflow: visible !important;\n}\n\n.card-body .btn-light {\n  width: 100%;\n  background-color: transparent !important;\n  border: none !important;\n  padding: 8px 12px !important;\n  margin-bottom: 8px;\n  border-radius: 8px !important;\n  transition: all 0.2s ease !important;\n}\n\n.card-body .btn-light:hover {\n  background-color: #F3F4F6 !important;\n}\n\n.card-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #6B7280;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  margin-bottom: 4px;\n  text-align: center;\n  width: 100%;\n}\n\n/* 优化按钮样式 */\n.card-body .btn {\n  border-radius: 8px !important;\n  font-weight: 500 !important;\n  padding: 10px 20px !important;\n  font-size: 14px !important;\n  transition: all 0.3s ease !important;\n  border: none !important;\n  text-transform: none !important;\n  letter-spacing: 0.3px;\n  width: 100%;\n  margin: 4px 0;\n}\n\n.card-body .btn-outline-secondary {\n  background-color: white !important;\n  color: #6B7280 !important;\n  border: 2px solid #E5E7EB !important;\n}\n\n.card-body .btn-outline-secondary:hover {\n  background-color: #F9FAFB !important;\n  color: #374151 !important;\n  border-color: #D1D5DB !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;\n}\n\n.card-body .btn-outline-primary {\n  background-color: white !important;\n  color: #3B82F6 !important;\n  border: 2px solid #3B82F6 !important;\n}\n\n.card-body .btn-outline-primary:hover {\n  background-color: #3B82F6 !important;\n  color: white !important;\n  border-color: #3B82F6 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;\n}\n\n.card-body .btn-primary {\n  background-color: #3B82F6 !important;\n  color: white !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25) !important;\n}\n\n.card-body .btn-primary:hover {\n  background-color: #2563EB !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.35) !important;\n}\n\n.card-body .btn-secondary {\n  background-color: #6B7280 !important;\n  color: white !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(107, 114, 128, 0.25) !important;\n}\n\n.card-body .btn-secondary:hover {\n  background-color: #4B5563 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(107, 114, 128, 0.35) !important;\n}\n\n.card-body .btn-danger {\n  background-color: #EF4444 !important;\n  color: white !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25) !important;\n}\n\n.card-body .btn-danger:hover {\n  background-color: #DC2626 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35) !important;\n}\n\n.card-body .btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.add-group {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n}\n\n.dataset-option {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n}\n\n.dataset-group {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 20px 24px;\n  margin: 0 0 24px 0;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n/* 美化顶部按钮栏中的按钮 */\n.dataset-option .btn {\n  border-radius: 8px !important;\n  font-weight: 500 !important;\n  padding: 10px 24px !important;\n  font-size: 14px !important;\n  transition: all 0.3s ease !important;\n  border-width: 2px !important;\n  letter-spacing: 0.3px;\n  text-transform: none !important;\n}\n\n/* Toolbar uses org-btn — legacy Bootstrap overrides removed */\n\n.dataset-option .btn-secondary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n  border: none !important;\n  color: white !important;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25) !important;\n}\n\n.dataset-option .btn-secondary:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.35) !important;\n}\n\n.dataset-option .btn-outline-danger {\n  background-color: #fff5f5 !important;\n  color: #e53e3e !important;\n  border-color: #feb2b2 !important;\n}\n\n.dataset-option .btn-outline-danger:hover {\n  background-color: #e53e3e !important;\n  color: white !important;\n  border-color: #e53e3e !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3) !important;\n}\n\n/* 美化 Create new dataset 按钮 */\n.add-group .btn-primary {\n  background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%) !important;\n  border: none !important;\n  border-radius: 10px !important;\n  padding: 12px 28px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.5px;\n  box-shadow: 0 4px 14px rgba(49, 130, 206, 0.3) !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.add-group .btn-primary:hover {\n  transform: translateY(-3px) scale(1.02) !important;\n  box-shadow: 0 8px 20px rgba(49, 130, 206, 0.4) !important;\n}\n\n.add-group .btn-primary:active {\n  transform: translateY(-1px) scale(0.98) !important;\n}\n\n/* Tab标签页优化 */\n.nav-tabs {\n  border-bottom: 2px solid #e2e8f0 !important;\n  margin-bottom: 24px;\n}\n\n.nav-tabs .nav-link {\n  border: none !important;\n  color: #718096 !important;\n  font-weight: 500 !important;\n  padding: 12px 24px !important;\n  margin-right: 4px !important;\n  border-radius: 8px 8px 0 0 !important;\n  transition: all 0.3s ease !important;\n  position: relative;\n}\n\n.nav-tabs .nav-link:hover {\n  color: #667eea !important;\n  background-color: #f7fafc !important;\n}\n\n.nav-tabs .nav-link.active {\n  color: #667eea !important;\n  background-color: transparent !important;\n  border-bottom: 3px solid #667eea !important;\n  font-weight: 600 !important;\n}\n\n/* 复选框美化 */\n.form-check-input {\n  width: 20px !important;\n  height: 20px !important;\n  border-radius: 6px !important;\n  border: 2px solid #D1D5DB !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  background-color: white !important;\n}\n\n.form-check-input:checked {\n  background-color: #3B82F6 !important;\n  border-color: #3B82F6 !important;\n}\n\n.form-check-input:hover {\n  border-color: #3B82F6 !important;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n}\n\n.form-check-input:focus {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;\n}\n\n/* 数据集卡片上的关闭按钮 - 默认隐藏，只在卡片hover时显示（卡片角删除钮除外） */\n.card .btn-close:not(.dataset-card-delete) {\n  opacity: 0 !important;\n  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease !important;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background-color: transparent;\n}\n\n.card:hover .btn-close:not(.dataset-card-delete) {\n  opacity: 0.6 !important;\n}\n\n.card .btn-close:not(.dataset-card-delete):hover {\n  background-color: #FEE2E2 !important;\n  opacity: 1 !important;\n}\n\n.dataset-card .btn-close:hover {\n  transform: none !important;\n}\n\n/* 卡片内输入框和选择框样式 */\n.card-body input[type=\"text\"],\n.card-body input[type=\"number\"],\n.card-body input[type=\"email\"],\n.card-body input[type=\"password\"],\n.card-body select,\n.card-body textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  transition: all 0.3s ease;\n  margin: 4px 0;\n}\n\n.card-body input[type=\"text\"]:focus,\n.card-body input[type=\"number\"]:focus,\n.card-body input[type=\"email\"]:focus,\n.card-body input[type=\"password\"]:focus,\n.card-body select:focus,\n.card-body textarea:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.card-body input[type=\"text\"]:hover,\n.card-body input[type=\"number\"]:hover,\n.card-body input[type=\"email\"]:hover,\n.card-body input[type=\"password\"]:hover,\n.card-body select:hover,\n.card-body textarea:hover {\n  border-color: #3B82F6;\n}\n\n.card-body input::placeholder,\n.card-body textarea::placeholder {\n  color: #9CA3AF;\n}\n\n/* 卡片内select下拉箭头 */\n.card-body select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n  cursor: pointer;\n}\n\n/* 搜索框和分页选择框样式 */\n.form-control:focus,\n.form-select:focus {\n  border-color: #3B82F6 !important;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n  outline: none !important;\n}\n\n.form-control:hover,\n.form-select:hover {\n  border-color: #3B82F6 !important;\n}\n\n.datasets {\n  --dataset-card-control-height: 38px;\n  --dataset-card-preview-height: 92px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto 40px;\n}\n\n.dataset-overview {\n  margin-bottom: 20px;\n}\n\n.dataset-page-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 24px;\n  margin-bottom: 16px;\n}\n\n.dataset-page-heading h1 {\n  margin: 0;\n  color: #111827;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.dataset-page-heading p {\n  margin: 4px 0 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.dataset-kicker {\n  margin: 0 0 4px !important;\n  color: #2563eb !important;\n  font-size: 12px !important;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.dataset-status-pill,\n.dataset-page-heading .org-count-badge {\n  flex-shrink: 0;\n}\n\n.dataset-metric-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.dataset-metric-card {\n  position: relative;\n  overflow: hidden;\n  min-height: 92px;\n  padding: 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: #ffffff;\n}\n\n.dataset-metric-card::after {\n  content: \"\";\n  position: absolute;\n  right: 16px;\n  top: 18px;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: currentColor;\n  opacity: 0.12;\n}\n\n.dataset-metric-card strong {\n  display: block;\n  margin-top: 12px;\n  color: #111827;\n  font-size: 26px;\n  line-height: 1;\n}\n\n.metric-label {\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.metric-blue { color: #2563eb; }\n.metric-green { color: #16a34a; }\n.metric-violet { color: #7c3aed; }\n.metric-orange { color: #f97316; }\n.metric-slate { color: #64748b; }\n\n.dataset-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n  padding: 14px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: #ffffff;\n}\n\n.dataset-toolbar-actions,\n.dataset-toolbar-search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.dataset-toolbar-search {\n  flex-wrap: nowrap;\n}\n\n.dataset-selection-status {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.dataset-toolbar-search label {\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.dataset-toolbar-search .form-control {\n  width: 280px;\n  min-height: 38px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n}\n\n/* Shared dataset-card controls use the Data Acquisition dimensions. */\n.dataset-card-body .org-btn,\n.dataset-card-body .btn:not(.dataset-title-button) {\n  width: 100%;\n  height: var(--dataset-card-control-height);\n  min-height: var(--dataset-card-control-height);\n  max-height: var(--dataset-card-control-height);\n  padding: 0 14px !important;\n  box-sizing: border-box;\n  font-size: 13px;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dataset-toolbar .org-btn {\n  min-height: 40px;\n  padding: 9px 16px;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.dataset-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.datasetGallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 16px;\n  padding: 0;\n}\n\n.dataset-card.card {\n  position: relative;\n  align-items: stretch;\n  width: 100% !important;\n  min-height: 236px;\n  margin: 0;\n  border: 1px solid #e6edf7 !important;\n  border-radius: 16px !important;\n  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04) !important;\n  background: #ffffff !important;\n  overflow: hidden;\n}\n\n.dataset-card .btn-close:not(.dataset-card-delete) {\n  position: static;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  padding: 0;\n  border-radius: 6px;\n  opacity: 0.55 !important;\n  transition: background 160ms ease, color 160ms ease, opacity 160ms ease;\n}\n\n.dataset-card .dataset-card-delete {\n  position: relative;\n  justify-self: end;\n  grid-column: 3;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border-radius: 6px;\n  opacity: 0 !important;\n  pointer-events: none;\n  transition: opacity 160ms ease, background 160ms ease;\n}\n\n.dataset-card:hover .dataset-card-delete {\n  opacity: 0.55 !important;\n  pointer-events: auto;\n}\n\n.dataset-card-actions .btn-close:hover,\n.dataset-card .dataset-card-delete:hover {\n  background-color: #fde8e8 !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23d14343'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") !important;\n  background-size: 1em auto !important;\n  background-position: center !important;\n  background-repeat: no-repeat !important;\n  opacity: 1 !important;\n  transform: none;\n}\n\n.dataset-card.card:has(.form-check-input:checked) {\n  border-color: #60a5fa !important;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;\n}\n\n.dataset-card.card:hover {\n  transform: none !important;\n  border-color: #bfdbfe !important;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;\n}\n\n.dataset-card-header {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  column-gap: 8px;\n  width: 100%;\n  padding: 12px 12px 0;\n  box-sizing: border-box;\n}\n\n.dataset-card-checkbox {\n  position: relative !important;\n  float: none !important;\n  top: auto !important;\n  left: auto !important;\n  margin: 0 !important;\n  grid-column: 1;\n  justify-self: start;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.dataset-card-badges {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 0;\n  flex-wrap: wrap;\n  grid-column: 2;\n  justify-self: center;\n}\n\n.dataset-card-badges .org-role-badge {\n  text-transform: capitalize;\n  font-size: 11px;\n}\n\n.dataset-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dataset-card-actions .org-role-badge {\n  text-transform: capitalize;\n  font-size: 11px;\n}\n\n.dataset-card-body.card-body {\n  width: 100%;\n  max-width: none;\n  align-items: stretch;\n  padding: 12px 16px 16px !important;\n  gap: 10px;\n  min-height: 180px;\n  box-sizing: border-box;\n}\n\n.dataset-card-body > * {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.dataset-title-button.btn-light {\n  width: 100%;\n  padding: 0 !important;\n  margin: 0 !important;\n  text-align: left;\n}\n\n.dataset-title-button .card-title {\n  color: #0f172a;\n  font-size: 16px;\n}\n\n.dataset-card-preview {\n  height: var(--dataset-card-preview-height);\n  min-height: var(--dataset-card-preview-height);\n  max-height: var(--dataset-card-preview-height);\n  flex: 0 0 var(--dataset-card-preview-height);\n  align-self: stretch;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-sizing: border-box;\n  background:\n    linear-gradient(135deg, rgba(37, 99, 235, 0.12), rgba(14, 165, 233, 0.06)),\n    repeating-linear-gradient(45deg, #f8fafc 0, #f8fafc 8px, #f1f5f9 8px, #f1f5f9 16px);\n}\n\n.dataset-card-preview.is-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed #cbd5e1;\n  background: #f8fafc;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.dataset-card-preview.has-image {\n  background: #f8fafc;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.dataset-card-preview.has-audio-waveform {\n  background-color: #f5f3ff;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.dataset-media-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.media-image { background: #ecfdf5; color: #047857; }\n.media-audio { background: #f5f3ff; color: #6d28d9; }\n.media-table { background: #fff7ed; color: #c2410c; }\n\n.dataset-status-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.status-ready {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.status-empty {\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.dataset-card-footer {\n  margin-top: auto;\n  padding-top: 12px;\n}\n\n.dataset-view-details {\n  width: 100%;\n  min-height: 38px;\n  border: 1px solid #111827;\n  border-radius: 8px;\n  background: #111827;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease;\n}\n\n.dataset-view-details:hover {\n  background: #1f2937;\n  border-color: #1f2937;\n}\n\n.dataset-gallery-summary {\n  margin-top: 14px;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.dataset-enterprise-modal .modal-content {\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);\n}\n\n.dataset-modal-header {\n  border-bottom: 1px solid #e5e7eb !important;\n  padding: 18px 22px !important;\n}\n\n.dataset-modal-header .modal-title {\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.dataset-modal-body {\n  padding: 22px !important;\n  background: #ffffff;\n}\n\n.dataset-modal-form {\n  display: grid;\n  gap: 18px;\n}\n\n.dataset-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dataset-modal-field label {\n  margin: 0;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.dataset-modal-field input,\n.dataset-modal-field .form-control,\n.dataset-modal-field select {\n  min-height: 40px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  color: #0f172a;\n  font-size: 14px;\n}\n\n.dataset-modal-field input:focus,\n.dataset-modal-field .form-control:focus,\n.dataset-modal-field select:focus {\n  border-color: #2563eb !important;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;\n}\n\n.dataset-file-dropzone {\n  display: grid;\n  gap: 10px;\n  padding: 14px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  transition: border-color 160ms ease, background 160ms ease;\n}\n\n.dataset-file-dropzone.is-drag-active {\n  border-color: #2563eb;\n  background: #eff6ff;\n}\n\n.dataset-file-dropzone.is-disabled {\n  opacity: 0.65;\n  pointer-events: none;\n}\n\n.dataset-file-dropzone input[type=\"file\"] {\n  display: none;\n}\n\n.dataset-file-input {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dataset-file-browse {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 0 16px;\n  border: 1px solid #111827;\n  border-radius: 8px;\n  background: #111827;\n  color: #ffffff !important;\n  cursor: pointer;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  transition: background 160ms ease;\n}\n\n.dataset-file-browse:hover {\n  background: #1f2937;\n}\n\n.dataset-file-name {\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dataset-file-drop-hint {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.dataset-modal-panel {\n  display: grid;\n  gap: 14px;\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.dataset-modal-link {\n  color: #2563eb !important;\n  cursor: pointer;\n  font-weight: 800;\n  text-decoration: none !important;\n}\n\n.dataset-modal-footer.org-modal-footer {\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.dataset-modal-tip {\n  flex: 1;\n  margin: 0;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.dataset-modal-actions {\n  margin-left: auto;\n}\n\n.dataset-modal-actions .org-btn {\n  min-height: 40px;\n  font-size: 14px;\n}\n\n.dataset-modal-progress {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.dataset-modal-progress progress {\n  flex: 1;\n  height: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n}\n\n.dataset-modal-progress span {\n  color: #334155;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.dataset-tab-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dataset-tab-count {\n  min-width: 22px;\n  padding: 1px 7px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #e5e7eb !important;\n  margin-bottom: 18px;\n}\n\n.nav-tabs .nav-link {\n  border-radius: 10px 10px 0 0 !important;\n  color: #64748b !important;\n}\n\n.nav-tabs .nav-link.active {\n  color: #2563eb !important;\n  border-bottom: 2px solid #2563eb !important;\n}\n\n.dataset-search-hint {\n  display: inline-flex;\n  margin-bottom: 12px;\n  padding: 7px 12px;\n  border: 1px solid #dbeafe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.dataset-empty-state {\n  border: 1px dashed #cbd5e1;\n  border-radius: 14px;\n  background: #f8fafc;\n  padding: 40px;\n  text-align: center;\n  color: #64748b;\n}\n\n.dataset-toolbar {\n  min-height: 58px;\n  gap: 12px;\n}\n\n.dataset-toolbar-actions,\n.dataset-toolbar-search {\n  gap: 12px;\n}\n\n.dataset-toolbar-search label,\n.dataset-toolbar-search .form-control {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.dataset-toolbar-search label {\n  margin: 0;\n  color: #334155;\n}\n\n.dataset-toolbar-search .form-control {\n  width: 280px;\n  min-height: 40px;\n  color: #0f172a;\n}\n\n.dataset-group-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 16px;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.dataset-group-header h3 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.dataset-empty-trash-button {\n  min-height: 36px;\n  padding: 7px 12px;\n  white-space: nowrap;\n}\n\n@media (max-width: 1100px) {\n  .dataset-metric-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .dataset-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .dataset-toolbar-search,\n  .dataset-toolbar-search .form-control {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
